// extracted by css-extract-rspack-plugin
export default {"wrapper":"_fee49f7f","scaler":"_1ddc01e6"};